import React, { useEffect, useState } from "react";

const ImageUpload = ({ label, name, accept, formik, initialImage, blankImg }) => {
    const [preview, setPreview] = useState("");

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result);
                formik.setFieldValue(name, file);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemoveImage = () => {
        setPreview("");
        formik.setFieldValue(name, "");
    };

    useEffect(() => {
        if (initialImage) setPreview(initialImage);
    }, []);

    return (
        <>
            <div className="upload-image-btn">
                <i className="bi bi-cloud-arrow-up"></i> {label}
                <input
                    accept={accept || "image/*"}
                    type="file"
                    name={name}
                    onChange={handleFileChange}
                    onClick={(event) => event.target.value = null}
                />
            </div>
            <div className="ps-img-box">
                <img
                    className="ps-img-upload-fluid"
                    src={preview || blankImg}
                    alt={label || "Uploaded Image"}
                />
                {preview && (
                    <button type="button" onClick={handleRemoveImage} className="ps-close-btn btn">
                        <i className="bi bi-x"></i>
                    </button>
                )}
            </div>
        </>
    );
};

export {
    ImageUpload
};
